import { render } from "./AdminResult.vue?vue&type=template&id=cb6362be&scoped=true"
import script from "./AdminResult.vue?vue&type=script&lang=js"
export * from "./AdminResult.vue?vue&type=script&lang=js"

import "./AdminResult.vue?vue&type=style&index=0&id=cb6362be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb6362be"]])

export default __exports__